<template v-if="!cartStore.loadingCart">
  <div class="m-shipment__head">
    <h2 class="m-shipment__head-title a-h4">
      {{ t('cart.shipment.title') }}
    </h2>
    <span class="m-shipment__head-text">
      {{ t('cart.shipment.description') }}
    </span>
  </div>
  <base-select type="checkout" v-model="selectedCheckoutCountry" @update:model-value="setCountry($event)" :options="countries" />
  <fieldset class="m-shipment__methods">
    <legend class="u-screen-reader-only">
      {{ t('cart.shipment.description') }}
    </legend>
    <div class="m-shipment__method"
      :class="{ active: shippingMethod.ID.toString() === cartStore.cart.checkout_method?.shipping_method?.ID.toString() }"
      v-for="shippingMethod of cartStore.shippingMethods">
      <input type="radio" :value="shippingMethod.ID"
        @change="cartStore.setCheckoutMethod(shippingMethod.checkout_method_id)" name="shipping_method"
        :id="'shipping_' + shippingMethod.ID.toString() + selectedCheckoutCountry?.id"
        :checked="shippingMethod.ID.toString() === cartStore.cart.checkout_method?.shipping_method?.ID.toString()" />
      <label :for="'shipping_' + shippingMethod.ID.toString() + selectedCheckoutCountry?.id">
        <span class="m-shipment__method-title">
          {{ shippingMethod.name }}
        </span>
        <div class="m-shipment__method-details"
          v-if="shippingMethod.internal_name.toLowerCase() === 'postnl' && cartStore.selectedTimeFrame !== null">
          <span>
            {{ cartStore.selectedTimeFrame?.label }}
          </span>
        </div>
      </label>
    </div>
  </fieldset>

  <a :href="generateRoute('checkout')" class="m-shipment__btn a-btn a-btn--checkout">
    {{ t('cart.button.checkout') }}
  </a>
</template>

<script setup lang="ts">
import { Ref, computed, onMounted, ref, watch } from 'vue'
import { useCartStore } from '../../stores/cart'
import BaseSelect, { Option } from '../BaseSelect.vue'
import { useI18n } from 'vue-i18n'
import { generateRoute } from '../../helper-functions'

const { t } = useI18n()
const cartStore = useCartStore()
const selectedCheckoutCountry: Ref<Option | null> = ref(null)
const countries = computed(() => {
  return cartStore.checkoutCountries.map(country => {
    return {
      id: country.ID,
      label: country.name,
    }
  })
})

onMounted(async () => {
  await cartStore.init()

  updateSelectedValues()
})

watch(() => cartStore.cart, () => {
  updateSelectedValues()
})

function updateSelectedValues() {
  if (cartStore.cart.country === null) {
    return
  }

  selectedCheckoutCountry.value = {
    id: cartStore.cart.country.ID,
    label: cartStore.cart.country.name,
  }
}

function setCountry(event: Option | null) {
  if (event === null || event.id === cartStore.cart.country?.ID) {
    return
  }

  cartStore.setCheckoutCountry(event.id)
}
</script>
